import HeadsetInterface from 'resources/headsets/headset-interface';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';
import isElectron from 'is-electron';

const ipcRenderer = isElectron() ? require('electron').ipcRenderer : null;

export default class Jabra4Headset extends HeadsetInterface {
    attachCallbacks = (callbacks) => {
        this.callbacks = callbacks(this.id);
        ipcRenderer.send('jabraAttachCallbacks');
        ipcRenderer.on('jabraDisconnectEvent', this.callbacks.onDisconnect);
        ipcRenderer.on('jabraMuteEvent', this.callbacks.onMuteEvent);
        ipcRenderer.on('jabraUnmuteEvent', this.callbacks.onUnmuteEvent);
        ipcRenderer.on('jabraHoldEvent', this.callbacks.onHoldCall);
        ipcRenderer.on('jabraUnholdEvent', this.callbacks.onUnholdCall);
        ipcRenderer.on('jabraAcceptedEvent', this.callbacks.onAcceptCall);
        ipcRenderer.on('jabraOnHangupEvent', this.callbacks.onHangup);
        return this;
    };

    async incomingCallImpl() {
        addHeadsetLogEntry('Jabra signalIncomingCall');
        ipcRenderer.send('jabraIncomingCall');
    }

    async outgoingCallImpl() {
        addHeadsetLogEntry('Jabra startCall');
        ipcRenderer.send('jabraOutgoingCall');
    }

    async confirmCallImpl(_callId, incoming, answeredThroughHeadset) {
        if (!incoming || answeredThroughHeadset) {
            return;
        }
        ipcRenderer.send('jabraConfirmCall');
    }

    async endCallImpl(_callId, hungupThroughHeadset) {
        if (hungupThroughHeadset) {
            return;
        }
        ipcRenderer.send('jabraEndCall');
    }

    async holdCallImpl() {
        addHeadsetLogEntry('Jabra hold');
        ipcRenderer.send('jabraHoldCall');
    }

    async resumeCallImpl() {
        addHeadsetLogEntry('Jabra resume');
        ipcRenderer.send('jabraResumeCallImpld');
    }

    async muteCallImpl() {
        addHeadsetLogEntry('Jabra mute');
        ipcRenderer.send('jabraMuteCall');
    }

    async unmuteCallImpl() {
        addHeadsetLogEntry('Jabra unmute');
        ipcRenderer.send('jabraUnmuteCall');
    }

    onDisconnectImpl() {
        ipcRenderer.send('jabraDisconnect');
    }
}
